/**
 * Currency Configuration
 *
 * Single source of truth for all currency formatting in the application.
 * Both the <Price /> component and toCurrency() function use this formatter.
 */

export const CURRENCY_CONFIG = {
    locale: 'en-US',
    currency: 'USD',
}

/**
 * Shared Intl.NumberFormat instance for currency formatting.
 * Using a single instance is more performant than creating new ones.
 */
export const currencyFormatter = new Intl.NumberFormat(CURRENCY_CONFIG.locale, {
    style: 'currency',
    currency: CURRENCY_CONFIG.currency,
})
